export default "__VITE_ASSET__CZh3cWO1__"